import store from '@/store';
import { isPrivateMode } from '@/utils/app-mode';
import { environments } from '../config/configManager';
import { createHttpClient } from './create-http-client';

const logOut = () => {
  if (isPrivateMode()) {
    store.dispatch('plans-auth/doLogout');
  } else {
    store.dispatch('users/doLogout');
  }
};

const retrieveToken = () => {
  const userStr = localStorage.getItem('user');
  if (userStr === 'undefined' || !userStr) {
    logOut();
    return;
  }
  try {
    const user = JSON.parse(userStr);
    if (isPrivateMode()) {
      store.dispatch('plans-auth/refreshToken', {
        token: localStorage.getItem('refreshToken'),
        username: user.username,
      });
    } else {
      store.dispatch('users/refreshToken', {
        token: localStorage.getItem('refreshToken'),
        username: user.username,
      });
    }
  } catch {
    logOut();
  }
};

const client = createHttpClient({
  baseURL: environments.planApi,
  getAuthHeaders: () => {
    if (isPrivateMode()) {
      const accessToken = localStorage.getItem('token');
      return accessToken ? { Authorization: accessToken } : {};
    }
    const accessToken = localStorage.getItem('token');
    return accessToken ? { Authorization: accessToken } : {};
  },
  afterSuccess: () => {},
  afterError: ({ status, isNetwork, requestUrl }) => {
    if (isNetwork) return;
    const isLoginRequest = requestUrl.includes('/auth/login');
    if (isLoginRequest) {
      return;
    }
    switch (status) {
      case 401:
        retrieveToken();
        break;
      case 403:
        retrieveToken();
        break;
      default:
        break;
    }
  },
});

export default client;
